import { useQueryEditor } from '@graphiql/react';
import React from 'react';
export function QueryEditor(props) {
  var ref = useQueryEditor(props);
  return React.createElement("section", {
    className: "query-editor",
    "aria-label": "Query Editor",
    ref: ref
  });
}